export const OPACITY_100 = 1;
export const OPACITY_88 = 0.88;
export const OPACITY_73 = 0.73;
export const OPACITY_70 = 0.7;
export const OPACITY_33 = 0.33;
export const OPACITY_20 = 0.2;
export const OPACITY_13 = 0.13;
export const OPACITY_5 = 0.05;
